import { Inject, Injectable } from '@angular/core';
import { bindNodeCallback } from 'rxjs';
import { Auth0SignUpOptions } from './models/auth0-sign-up-options.model';
import { SignUpOptions } from 'src/app/auth/models/sign-up-options.model';
import { AUTH0_WEBAUTH } from 'src/app/shared/injection-tokens/auth0-web-auth.injection-token';
import { Auth0Error } from './models/auth0-error.model';

@Injectable({ providedIn: 'root' })
export class SignUpService {
  // auth0 is the object returned from the Auth0 WebAuth constructor function
  // however auth0.js is not typed so we use any
  constructor(@Inject(AUTH0_WEBAUTH) private auth0WebAuth: any) {}

  public signUp(options: SignUpOptions) {
    const auth0Options: Auth0SignUpOptions = {
      connection: 'Username-Password-Authentication',
      email: options.email,
      password: options.password,
      given_name: options.firstName,
      family_name: options.lastName,
      user_metadata: {
        companyName: options.organization,
        organizationType: options.organizationType,
        organizationSubscriptionInterval: options.organizationSubscriptionInterval,
        emailSubscribe: options.allowMarketingEmails ? 'opted_in' : 'subscribed',
        registrationSource: 'studio-registration',
      },
    };

    // convert Auth0 function with callback to function emitting an observable or error
    const auth0Signup = bindNodeCallback(
      // auth0-js is not typed so explicitly type auth0.signup which results in the bound function
      // having (partially) correct types
      this.auth0WebAuth.signup.bind(this.auth0WebAuth) as (
        options: Auth0SignUpOptions,
        callback: (err: Auth0Error, result: any) => void,
      ) => any,
    );

    return auth0Signup(auth0Options);
  }
}
